import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import InputField from "components/Input";
import SelectField from "components/Select";
import Colors from "assets/Style/Colors";
import { useNavigate } from "react-router-dom";
import UploadFile from "components/UploadFile";

const departments = [

  { id: "Finance", name: "Finance" },
  { id: "IT", name: "IT" },
];
const types = [

  { id: "Complaint", name: "Complaint" },
  { id: "Inquiry", name: "Inquiry" },
  { id: "Issue", name: "Issue" },
];

const CreateSupportTicket = () => {
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [ticketType, setTicketType] = useState(types[0]);
  const [assignedDepartment, setAssignedDepartment] = useState(departments[0]);
  const [attachment, setAttachment] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [uploadedFileDetail, setUploadedFileDetail] = useState([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const navigate = useNavigate();
  const allowFilesTypeTicket = ["application/pdf", "image/jpg", "image/jpeg"];

  // These would come from auth/context in a real app
  const userName = "All";
  const department = "Finance";
  const dateTime = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });


  // Utility for file size formatting
  const getFileSize = (size) => {
    if (!size) return "0 B";
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " + ["B", "KB", "MB", "GB", "TB"][i]
    );
  };

  // File upload handler (similar to BookBill)
  const handleUploadTicketFile = async (e) => {
    try {
      e.preventDefault();
      setIsFileSelected(true);
      setIsFileUploaded(false);
      const file = e.target.files[0];
      let arr = [
        {
          id: file?.name + Date.now(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeTicket.includes(file.type)) {
        setUploadedFileDetail(arr);
        setAttachment(file);
        await handleUploadFileToServer(file, arr);
      } else {
        alert(`Only PDF, JPG formats are supported`);
      }
    } catch (error) {
      alert(error);
    }
  };

  // Simulate upload (replace with actual API call if needed)
  const handleUploadFileToServer = async (file, docs) => {
    setUploadProgress(0);
    try {
      // Simulate upload progress
      setTimeout(() => {
        setUploadProgress(100);
        setUploadedSize(getFileSize(file.size));
        docs[0].isUpload = true;
        docs[0].file = file.name;
        setUploadedFileDetail(docs);
        setIsFileUploaded(true);
      }, 1000);
    } catch (error) {
      alert(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/customers/support-tickets");
  };

  return (
    <Box sx={{ p:4 }}>
      {/* Page Title */}
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mb: 3, color: Colors.charcoalGrey }}
      >
        Create Ticket
      </Typography>

      <form onSubmit={handleSubmit} autoComplete="off">
        <Grid container spacing={2.5}>
          {/* Row 1: User Name | Department | Date & Time */}
          <Grid item xs={12} sm={3}>
            <InputField
              label="User Name"
              value={userName}
              size="small"
              disabled
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputField
              label="Department"
              value={department}
              size="small"
              disabled
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputField
              label="Date & Time"
              value={dateTime}
              size="small"
              disabled
              onChange={() => {}}
            />
          </Grid>

          {/* Section Heading */}
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: 600, mt: 1, color: Colors.charcoalGrey, fontSize: 18 }}
            >
              Add Ticket Details
            </Typography>
          </Grid>

          {/* Subject */}
          <Grid item xs={12} sm={9}>
            <InputField
              label="Subject*"
              placeholder="Enter a breif subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              size="small"
              required
            />
          </Grid>

          {/* Description */}
          <Grid item xs={12} sm={9}>
            <InputField
              label="Description*"
              placeholder="Describe the issue / request"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              size="small"
              required
              
            />
          </Grid>
<Grid container item xs={12} spacing={2.5} alignItems="center" mt={4}>
          {/* Ticket Type | Assigned Department */}
          <Grid item xs={12} sm={3}>
            <SelectField
              label="Ticket Type*"
              size="small"
              options={types}
              selected={ticketType}
              onSelect={setTicketType}
              optionIdKey="id"
              optionLabelKey="name"
              placeholder="Select Ticket Type"
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label="Assigned Department*"
              size="small"
              options={departments}
              selected={assignedDepartment}
              onSelect={setAssignedDepartment}
              optionIdKey="id"
              optionLabelKey="name"
              placeholder="Select Department"
              required
            />
          </Grid>

          <Grid item xs={12} sm={3} mt={1}>
            <UploadFile
              custom={true}
              vendor={true}
              acceptedFormats="PDF, JPG"
              style={{
                backgroundColor: "#e7efeb",
                width: "100%",
                height: "40px",
                display: "flex",
                justifyContent: "space-between",
                padding: "20px",
                border: "1px dashed #aeb1b0",
                borderRadius: "10px",
              }}
              register={{
                onChange: (e) => handleUploadTicketFile(e),
              }}
            />
            {/* Show upload progress and file info */}
            {isFileSelected && uploadedFileDetail.length > 0 && (
              <Box mt={1}>
                <Typography variant="body2">
                  {uploadedFileDetail[0].name} ({uploadedFileDetail[0].size})
                  {isFileUploaded ? " - Uploaded" : " - Uploading..."}
                </Typography>
                <Box sx={{ width: "100%", background: "#eee", borderRadius: 1,  }}>
                  <Box
                    sx={{
                      width: `${uploadProgress}%`,
                      background: Colors.primary,
                      height: 6,
                      borderRadius: 1,
                      transition: "width 0.3s",
                    }}
                  />
                </Box>
              </Box>
            )}
          </Grid>

</Grid>
          {/* Submit Button */}
          <Grid item xs={12} sm={11} sx={{ textAlign: "right", mt: 4, mr: 2 }}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: Colors.primary,
                color: "#fff",
                borderRadius: 2,
                px: 5,
                fontWeight: 700,
                fontSize: 15,
                boxShadow: "none",
                height: 44,
                minWidth: 130,
                textTransform: "none",
                "&:hover": { bgcolor: Colors.primary, boxShadow: "none" },
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CreateSupportTicket;